import { render, staticRenderFns } from "./request-public-documents.vue?vue&type=template&id=3e7113bc&"
import script from "./request-public-documents.vue?vue&type=script&lang=js&"
export * from "./request-public-documents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports